import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { ApiError } from './lib/api';
// Must run before any editor renders: it redirects Monaco away from the
// public CDN it would otherwise load itself from.
import './lib/monaco-setup';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Schema and datasource lists change rarely; refetching them on every
      // window focus is noise. The catalog has its own explicit refresh.
      staleTime: 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Retrying an authentication or permission failure just produces the
        // same answer three times more slowly.
        if (error instanceof ApiError) {
          if (error.needsReauth) return false;
          if (error.status && error.status < 500) return false;
        }
        return failureCount < 2;
      },
    },
    mutations: { retry: false },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
